import { useCallback } from "react";
import useRightSidebar from "hooks/useRightSidebar";
function useAssetPanel() {
  var _a;
  const { openSidebar, closeSidebar, content } = useRightSidebar();
  const selectedAssetId = (_a = content == null ? void 0 : content.props) == null ? void 0 : _a.assetId;
  const openAssetDetails = useCallback(
    (asset) => {
      openSidebar({
        id: `asset-${asset.id}`,
        title: "Asset Details",
        componentKey: "AssetSidebarContent",
        props: { assetId: asset.id }
      });
    },
    [openSidebar]
  );
  const closeAssetDetails = useCallback(() => {
    closeSidebar();
  }, [closeSidebar]);
  return {
    selectedAssetId,
    openAssetDetails,
    closeAssetDetails
  };
}
export default useAssetPanel;
